// src/components/ui/Button/ButtonVoltar.jsx
import React from "react";

export default function ButtonVoltar({ onClick, texto = "Voltar" }) {
  return (
    <button
      onClick={onClick}
      className="px-7 py-2.5 rounded-sm text-white font-medium transition-colors duration-200 active:scale-[0.98]"
      style={{
        backgroundColor: "#b50000",
        fontFamily: "Roboto, Helvetica, Arial, sans-serif",
        boxShadow: "none",
      }}
      onMouseEnter={(e) => (e.target.style.backgroundColor = "#d10000")}
      onMouseLeave={(e) => (e.target.style.backgroundColor = "#b50000")}
      onMouseDown={(e) => (e.target.style.backgroundColor = "#b50000")}
      onMouseUp={(e) => (e.target.style.backgroundColor = "#d10000")}
    >
      {texto}
    </button>
  );
}
